// LICENSE : MIT
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *  XXX: This is exported for an unit testing.
 *  DO NOT USE THIS in your application.
 */
exports.TYPE = "__ALMIN_ERROR_PAYLOAD__";
/**
 * This payload is executed
 */
var ErrorPayload = /** @class */ (function () {
    function ErrorPayload(_a) {
        var error = _a.error;
        this.type = exports.TYPE;
        this.error = error;
    }
    return ErrorPayload;
}());
exports.ErrorPayload = ErrorPayload;
function isErrorPayload(v) {
    return v.type === exports.TYPE;
}
exports.isErrorPayload = isErrorPayload;
//# sourceMappingURL=ErrorPayload.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/payload/ErrorPayload.js
// module id = 57
// module chunks = 0